var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 72,
    viewBox: "0 0 51 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1373_2530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8333 32C30.8333 28.4427 36.6039 26.0107 39.7222 21.3333C43.2777 16 43.2777 3.55554 43.2777 3.55554H7.72217C7.72217 3.55554 7.72217 16 11.2777 21.3333C14.3959 26.0107 20.1666 28.4427 20.1666 32C20.1666 35.5573 14.3959 37.9893 11.2777 42.6667C7.72217 48 7.72217 60.4444 7.72217 60.4444H43.2777C43.2777 60.4444 43.2777 48 39.7222 42.6667C36.6039 37.9893 30.8333 35.5573 30.8333 32Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 3.55554H11.2778C11.2778 3.55554 11.2778 10.6667 13.0556 16C15.3738 22.9547 23.7223 24.8871 23.7223 32C23.7223 39.1129 23.7223 55.1111 25.5001 55.1111C27.2778 55.1111 27.2778 39.1111 27.2778 32C27.2778 24.8889 35.6281 22.9547 37.9445 16C39.7223 10.6667 39.7223 3.55554 39.7223 3.55554H25.5001Z",
    fill: "#FFAC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8332 60.4444C46.8332 62.4071 45.2403 64 43.2776 64H7.72206C5.75939 64 4.1665 62.4071 4.1665 60.4444C4.1665 58.4818 5.75939 56.8889 7.72206 56.8889H43.2776C45.2403 56.8889 46.8332 58.4818 46.8332 60.4444ZM46.8332 3.55556C46.8332 5.51822 45.2403 7.11111 43.2776 7.11111H7.72206C5.75939 7.11111 4.1665 5.51822 4.1665 3.55556C4.1665 1.59289 5.75939 0 7.72206 0H43.2776C45.2403 0 46.8332 1.59289 46.8332 3.55556Z",
    fill: "#3B88C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1373_2530",
    x: 0.166504,
    y: 0,
    width: 50.6665,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1373_2530"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1373_2530",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.99657897c95106285ca353fa70ec56ed.svg";
export { ForwardRef as ReactComponent };